// extracted by mini-css-extract-plugin
export default {"rating":"u5y6GW","star":"H1IYDY","fill":"zdcg42","button":"OSAJIf","size-40":"XNOhhJ","size-20":"jyi4r9","size-14":"g4onrI","size-9":"qWOPMe"};